import { Grid } from "@mui/material"
import pluginsList from "./toolbarIconsList";
import useOnClickListener from "./useOnClickListener";
import { createPortal } from "react-dom";
import FloatingLinkEditor from "./FloatingLinkEditor";

const Toolbar = () => {
    const { onClick, isLink, editor, modal, showModal } = useOnClickListener();

    return <Grid
        container
        sx={{background: "white", width: "100%", py: 1.5, px: 0.5}}
        alignItems={"center"}
        spacing={2}
    >
        {
            pluginsList.map((plugin) => (
                <Grid sx={{cursor: "pointer"}} item key={plugin.id}>
                    {<plugin.Icon onClick={() => onClick(plugin.event)}/>}
                </Grid>
            ))
        }

        {isLink && 
            createPortal(<FloatingLinkEditor editor={editor} />, document.body)}

        {modal}
    </Grid>
}

export default Toolbar;